import React, { useState, useEffect } from 'react';
import { Container, Modal, Form, Button } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import api from '../../../services/API';
import sortFunc from '../../../utils/ordernarColunaInt';

const ToSearch = (props) => {
  let input;
  const handleClick = () => {
    props.onSearch(input.value);
  };

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') {
      props.onSearch(input.value);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <input
        className="input-theme busca mr-1"
        ref={(n) => (input = n)}
        type="text"
        onKeyUp={handleEnterKey}
      />
      <button
        className="btn-primario-slim"
        onClick={handleClick}
        style={{ width: 40, height: 40 }}
      >
        <i className="fa fa-search px-2"></i>
      </button>
    </div>
  );
};

const permissoes = [
  { value: 1, label: 'Administrador' },
  { value: 2, label: 'Operador' },
  { value: 3, label: 'Coordenador' },
];

export default function Usuarios() {
  const history = useHistory();
  const [buscando, setBuscando] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    nome: '',
    cpf: '',
    email: '',
    senha: '',
    permissao: '',
  });

  useEffect(() => {
    buscarUsuarios();
  }, []);

  const buscarUsuarios = async () => {
    setBuscando(true);
    try {
      const resultado = await api.get('/api/usuarios');
      if (resultado && resultado.data) {
        setData(resultado.data.usuarios || []);
      }
    } catch (error) {
      toast.error('Erro ao buscar usuários', {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    setBuscando(false);
  };

  const handleEdit = (usuario) => {
    setFormData({
      id: usuario.id,
      nome: usuario.nome,
      cpf: usuario.cpf,
      email: usuario.email,
      senha: '',
      permissao: usuario.permissao || '',
    });
    setEditando(true);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({
      id: null,
      nome: '',
      cpf: '',
      email: '',
      senha: '',
      permissao: '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);

    try {
      const payload = {
        nome: formData.nome,
        email: formData.email,
        cpf: formData.cpf,
        permissao: Number(formData.permissao),
      };

      // Só envia senha se foi preenchida
      if (formData.senha) {
        payload.senha = formData.senha;
      }

      await api.put(`/api/usuarios/${formData.id}`, payload);
      toast.success('Usuário atualizado com sucesso!', {
        position: toast.POSITION.BOTTOM_CENTER,
      });

      handleCloseModal();
      buscarUsuarios();
    } catch (error) {
      // Erro já tratado pelo interceptor
    }
    setEnviando(false);
  };

  const handleNovoCadastro = () => {
    history.push('/painel/cadastrar/administrador');
  };

  const getPermissaoNome = (permissao) => {
    const perm = permissoes.find((p) => p.value === permissao);
    return perm ? perm.label : 'N/A';
  };

  const columns = [
    {
      dataField: 'nome',
      text: 'Nome',
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'cpf',
      text: 'CPF',
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'email',
      text: 'Email',
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'permissao',
      text: 'Permissão',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) => getPermissaoNome(cell),
    },
    {
      dataField: 'acoes',
      text: 'Ações',
      isDummyField: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell, row) => (
        <button className="btn-primario-slim" onClick={() => handleEdit(row)}>
          <i className="fa fa-edit mr-2"></i>
          Editar
        </button>
      ),
    },
  ];

  const options = {
    sizePerPage: 10,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const defaultSorted = [
    {
      dataField: 'nome',
      order: 'asc',
    },
  ];

  return (
    <Container fluid>
      <div className="d-flex justify-content-between align-items-center pt-3 pb-3">
        <h4 className="f-black mb-0">Usuários</h4>
        <div>
          <button className="btn-primario-slim" onClick={handleNovoCadastro}>
            <i className="fa fa-plus mr-2"></i>
            Novo Usuário
          </button>
        </div>
      </div>
      <hr className="hr-loja mt-0 mb-4" />
      <div>
        <ToolkitProvider
          bootstrap4
          keyField="id"
          data={data}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div className="d-flex flex-row-reverse mb-2">
                <ToSearch {...props.searchProps} />
              </div>
              <BootstrapTable
                noDataIndication={() =>
                  buscando ? (
                    <span>
                      Carregando
                      <i className="fas fa-circle-notch fa-spin ml-3"></i>
                    </span>
                  ) : (
                    <span>Sem resultados</span>
                  )
                }
                classes="table-dark text-center rounded"
                wrapperClasses="rounded"
                bordered={false}
                pagination={paginationFactory(options)}
                defaultSorted={defaultSorted}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>

      <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>Editar Usuário</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Nome *</Form.Label>
              <Form.Control
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleInputChange}
                required
                placeholder="Nome completo"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Email *</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                required
                placeholder="email@exemplo.com"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>CPF *</Form.Label>
              <Form.Control
                type="text"
                name="cpf"
                value={formData.cpf}
                onChange={handleInputChange}
                required
                maxLength={11}
                placeholder="Somente números"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Nova Senha</Form.Label>
              <Form.Control
                type="password"
                name="senha"
                value={formData.senha}
                onChange={handleInputChange}
                placeholder="Deixe em branco para não alterar"
              />
              <Form.Text className="text-muted">
                Preencha apenas se desejar alterar a senha
              </Form.Text>
            </Form.Group>

            <Form.Group>
              <Form.Label>Permissão *</Form.Label>
              <Form.Control
                as="select"
                name="permissao"
                value={formData.permissao || ''}
                onChange={handleInputChange}
                required
              >
                <option value="">Selecione uma permissão</option>
                {permissoes.map((perm) => (
                  <option key={perm.value} value={perm.value}>
                    {perm.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Cancelar
            </Button>
            <Button
              type="submit"
              variant="primary"
              disabled={enviando}
            >
              {enviando ? 'Salvando...' : 'Salvar'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
}

